/** Builds the URL for a given S3 `bucket`. */
export const s3BucketUrl = bucket => (bucket ? `https://${bucket}.s3.amazonaws.com` : '')

/** Builds the URL for the `content_images` directory that holds Everplan article images. */
export const s3ContentImagesUrl = () => `${s3BucketUrl(S3_IMAGES_BUCKET)}/content_images`

/** Builds the URL for a specific Everplan article image. */
export const contentImageUrl = imageName => (imageName ? `${s3ContentImagesUrl()}/${imageName}` : '')
